import {createListenerMiddleware} from '@reduxjs/toolkit';

import {httpMonitorAPI, clearAllHttpMonitors} from 'features/http';
import {portMonitorAPI} from 'features/port';
import {domainIncidentAPI, domainMonitorAPI, clearAllDomainMonitors} from 'features/domain';
import {serverAPI, clearAllServers} from 'features/server';
import {userSelector} from 'entities/user';
import {cacheCleared} from 'shared/api/cacheEvents';
import {ReduxState} from 'shared/model/types';
import {domainIncidentsStale, domainMonitorsStale, httpMonitorsStale, taggedEntitiesStale} from 'entities/monitor';

import {apis} from './apiRegistry';

export const cacheListener = createListenerMiddleware();

cacheListener.startListening({
    actionCreator: cacheCleared,
    effect: (_, {dispatch}) => {
        apis.forEach(api => dispatch(api.util.resetApiState()));
        dispatch(clearAllHttpMonitors(0));
        dispatch(clearAllDomainMonitors(0));
        dispatch(clearAllServers(0));
    },
});

cacheListener.startListening({
    actionCreator: httpMonitorsStale,
    effect: (_, {dispatch}) => {
        dispatch(httpMonitorAPI.util.invalidateTags(['HttpMonitor']));
    },
});

cacheListener.startListening({
    actionCreator: domainMonitorsStale,
    effect: (_, {dispatch}) => {
        dispatch(domainMonitorAPI.util.invalidateTags([
            {type: 'DomainMonitor', id: 'LIST'},
            'SummaryDomainMonitors',
        ]));
    },
});

cacheListener.startListening({
    predicate: (_, currentState, previousState) => {
        const previous = userSelector(previousState as ReduxState)?.tariff;
        const current = userSelector(currentState as ReduxState)?.tariff;

        return !!previous && !!current && (
            previous.id !== current.id
            || previous.domain_monitor_max_count_limit !== current.domain_monitor_max_count_limit
        );
    },
    effect: (_, {dispatch}) => {
        dispatch(domainMonitorAPI.util.invalidateTags(['SummaryDomainMonitors']));
    },
});

cacheListener.startListening({
    actionCreator: taggedEntitiesStale,
    effect: (_, {dispatch}) => {
        dispatch(httpMonitorAPI.util.invalidateTags(['HttpMonitor']));
        dispatch(portMonitorAPI.util.invalidateTags(['PortMonitor']));
        dispatch(domainMonitorAPI.util.invalidateTags(['DomainMonitor']));
        dispatch(serverAPI.util.invalidateTags(['Server']));
    },
});

cacheListener.startListening({
    actionCreator: domainIncidentsStale,
    effect: (_, {dispatch}) => {
        dispatch(domainIncidentAPI.util.invalidateTags(['DomainIncident', 'SummaryDomainIncident']));
    },
});
